<script>
import Help from '../icon/Help';

export default {
  components: {
    Help,
  },

  props: {
    integration: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    show: false,
    isEditing: true,
  }),

  mounted () {
    Bus.$on('hideConfig', () => {
      this.hideConfig();
    });

    Bus.$on('setIsEditing', (value) => {
      this.setIsEditing(value);
    });

    this.show = this.integration.showConfig;
  },

  methods: {
    hideConfig () {
      this.show = false;
    },

    setIsEditing (value) {
      this.isEditing = value;
    },

    handleEditButtonCLicked () {
      this.isEditing = true;

      Bus.$emit('editButtonClicked')
    },
  },

  computed: {
    headerOnly () {
      return ! this.integration.work && ! this.integration.know && ! this.show;
    },
  },
};
</script>

<template>
  <div>
    <div
      class="row"
    >
      <div
        class="col-12 pl-30px"
      >
        <h1
          class="page-title"
        >
          <span
            class="mr-2"
          >
            <a
              href="/integrations"
              v-text="__('Integrações')"
            />
          </span>

          >

          <span
            v-text="__(integration.name)"
            class="mx-2 bdk-cursor-pointer"
            @click="show = integration.showConfig"
          />

          {{ show ? '>' : '' }}

          <span
            class="ml-2"
            v-text="__('Configurações')"
            v-if="show"
          />
        </h1>
      </div>
    </div>

    <div
      class="row"
    >
      <div
        class="col-12 pl-30px d-flex"
      >
        <h2
          v-text="__(integration.name)"
          class="page-subtitle mb-0"
        />
      </div>
    </div>

    <div
      class="row board my-3 bdk-bg-white bdk-shadow-lg"
      :class="{
        'bdk-min-h-full': headerOnly,
      }"
    >
      <div
        class="bg-white bdk-w-full"
      >
        <div
          class="col-md-12 px-0 bdk-border-solid bdk-border-1 bdk-border-transparent bdk-border-b-gray-200 border-margin-x"
        >
          <div
            class="bdk-flex bdk-items-center bdk-justify-between bdk-py-8 bdk-px-8"
          >
            <div
              class="d-flex bdk-flex-col"
            >
              <img
                :src="integration.logo"
                :alt="integration.name"
                class="integration-logo-size"
              >

              <span
                v-if="! integration.showConfig && !integration.hideCategory"
                v-text="__(integration.category)"
                class="bdk-preflight bdk-text-sm bdk-font-medium text-salesflow-font-gray bdk-mt-2"
              />
            </div>

            <div
              v-if="! show"
            >
              <div>
                <button
                  class="btn btn-green"
                  v-if="! integration.url"
                  @click.prevent="show = ! show"
                  v-text="`${__('Configurar')} ${__(integration.name)}`"
                />

                <a
                  v-else
                  target="_blank"
                  :href="integration.url"
                >
                  <button
                    class="btn btn-green"
                    v-text="`${__('Configurar')} ${__(integration.name)}`"
                  />
                </a>
              </div>
            </div>

            <div v-if="show && integration.editable && !isEditing">
              <button
                @click="handleEditButtonCLicked"
                class="salesflow-btn salesflow-btn-primary"
              >
                {{ __('Atualizar integração') }}
              </button>
            </div>
            <div
              class="d-flex justify-content-center align-items-center help"
              v-else-if="integration.documentation"
            >
              <Help class="icon-help" />

              <span class="mb-0">
                <strong v-text="__('Precisa de ajuda')" />
                <u><a
                  target="_blank"
                  v-text="__('Ver documentação completa')"
                  :href="integration.documentation"
                /></u>
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="show"
        >
          <div
            class="row"
            v-if="integration.detail"
          >
            <div
              class="col-12"
            >
              <div
                class="d-flex justify-content-center"
              >
                <div
                  class="d-flex justify-content-start"
                >
                  <p
                    class="mb-5"
                    v-text="__(integration.detail)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="d-flex flex-column justify-content-center align-items-center bdk-py-8 bdk-max-w-[832px] bdk-mx-auto"
          >
            <Component
              :inline="true"
              class="bdk-w-full"
              :integration="integration"
              :is="integration.component"
              v-if="integration.component"
            />

            <div
              class="bdk-w-full"
            >
              <slot
                :name="integration.key"
              />
            </div>
          </div>
        </div>

        <div
          v-else-if="! headerOnly"
          class="bdk-py-12 bdk-px-10 bdk-preflight"
        >
          <div
            class="d-flex flex-column bdk-max-w-screen-md bdk-mx-auto"
          >
            <div
              v-if="integration.work"
              class="bdk-flex bdk-flex-col bdk-items-center"
            >
              <span
                v-text="`${__('Como trabalhar com')} ${__(integration.name)}`"
                class="bdk-text-xl bdk-font-medium bdk-text-gray-900 bdk-w-full"
              />

              <span
                v-html="integration.work"
                class="bdk-mt-4 bdk-text-base bdk-text-gray-500"
              />
            </div>

            <div
              class="bdk-w-full bdk-border-t bdk-border-gray-300 bdk-mx-auto bdk-my-6"
            />

            <div
              v-if="integration.know"
              class="bdk-flex bdk-flex-col bdk-items-center"
            >
              <span
                v-text="__('Saiba um pouco mais como integrar')"
                class="bdk-text-xl bdk-font-medium bdk-text-gray-900 bdk-w-full"
              />

              <span
                v-html="integration.know"
                class="bdk-mt-4 bdk-text-base bdk-text-gray-500 bdk-prose bdk-prose-indigo"
              />
            </div>
          </div>
        </div>
        <div v-else-if="integration.detail_component" class="bdk-py-12 bdk-px-10 bdk-preflight">
          <Component
            :inline="true"
            class="bdk-w-full"
            :integration="integration"
            :is="integration.detail_component"
            v-if="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../../sass/variables';
  .image-integration {
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }

  .row.board {
    min-height: 82.25vh;
  }

  .list {
    width: 60.8%;
  }

  .list-description {
    line-height: 2;
  }

  .search {
    width: 247px;
    height: 143px;
    background: #F6F5F8;
    border-radius: 19px;
  }

  .search-elements {
    margin: 38px 46px;
  }

  .configuration {
    margin-top: 21px,
  }

  .d-flex.justify-content-start p.mb-5 {
    margin-top: 15px;
  }

  .help {
    width: 350px;
    height: 44px;
    background: #F4F2F7;
    border-radius: 20px;
  }

  .icon-help {
    margin-right: 10px;
  }

  .code-size {
    font-size:unset;
  }

  .forms-title {
    color:$salesflow-font-gray;
  }

  .integration-form-text {
    margin-bottom: 0px;
  }

  .integration-form-description {
    margin-bottom: 8px;
  }

  .integration-form-custom-field-text {
    margin-bottom: 24px;
  }
  .integration-form-script-div {
    width: 100%;
    height: 183px;
    overflow: auto;
    position: relative;
    border: 1px solid $salesflow-outline-gray-medium;
    padding: 4px;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    background-color: $white-2;
    border-radius: 8px;
    margin-bottom: 24px;
    margin-top:24px;
  }
  .integration-form-script {
    width: 100%;
    height: 100%;
    overflow: auto;
    border: none;
    resize: none;
    box-sizing: border-box;
    color: $salesflow-font-gray;
    background-color: $white-2;
    padding: 8px 24px;
  }

  .integration-logo-size {
    max-height: 6.5rem;
    max-width: 9rem;
  }

  .bdk-border-1 {
    border-width:1px;
  }

  .border-margin-x {
    border-bottom-width: 1px;
    border-image: linear-gradient(
      to right,
      transparent 32px,
      #D1D1D1 32px,
      #D1D1D1 calc(100% - 32px),
      transparent calc(100% - 32px)
    ) 1;
    border-top-width: 0px;
  }

  .bdk-py-12 {
    padding-top: 64px !important;
    padding-bottom: 12% !important;
  }
</style>
